import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nyi',
  templateUrl: './nyi.component.html',
  styleUrls: ['./nyi.component.css']
})
export class NyiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
